import axiosInstance from "./axiosInstance";

// Export API methods
export const getRequest = (url, config = {}) => axiosInstance.get(url, config);
export const postRequest = (url, data, config = {}) => axiosInstance.post(url, data, config);
export const putRequest = (url, data, config = {}) => axiosInstance.put(url, data, config);
export const patchRequest = (url, data, config = {}) => axiosInstance.patch(url, data, config);
export const deleteRequest = (url, config = {}) => axiosInstance.delete(url, config);

// eslint-disable-next-line
// import React, { useEffect, useState } from "react";
// import {
//   getRequest,
//   postRequest,
//   putRequest,
//   patchRequest,
//   deleteRequest,
// } from "../../../common/api/apiService";

// const SampleCrudComponent = () => {
//   const [items, setItems] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const fetchData = async () => {
//     setLoading(true);
//     try {
//       const response = await getRequest("admin/fetch-tickets?page=0");
//       setItems(response.data.fetchedItems || []);
//     } catch (error) {
//       console.error("GET failed:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const createItem = async () => {
//     const newItem = { title: "New Ticket", status: 0 };
//     try {
//       const response = await postRequest("admin/create-ticket", newItem);
//       console.log("POST success:", response.data);
//     } catch (error) {
//       console.error("POST failed:", error);
//     }
//   };

//   const updateItem = async (id) => {
//     const updatedItem = { title: "Updated Title" };
//     try {
//       const response = await putRequest(`admin/update-ticket/${id}`, updatedItem);
//       console.log("PUT success:", response.data);
//     } catch (error) {
//       console.error("PUT failed:", error);
//     }
//   };

//   const patchItem = async (id) => {
//     const patchData = { status: 1 };
//     try {
//       const response = await patchRequest(`admin/patch-ticket/${id}`, patchData);
//       console.log("PATCH success:", response.data);
//     } catch (error) {
//       console.error("PATCH failed:", error);
//     }
//   };

//   const deleteItem = async (id) => {
//     try {
//       const response = await deleteRequest(`admin/delete-ticket/${id}`);
//       console.log("DELETE success:", response.data);
//     } catch (error) {
//       console.error("DELETE failed:", error);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, []);

//   return (
//     <div>
//       {loading && <p>Loading...</p>}
//       <h4>CRUD Demo</h4>
//       <button onClick={createItem}>Create Ticket</button>
//       <ul>
//         {items.map((item) => (
//           <li key={item._id}>
//             {item.ticket_title}
//             <button onClick={() => updateItem(item._id)}>Update</button>
//             <button onClick={() => patchItem(item._id)}>Patch</button>
//             <button onClick={() => deleteItem(item._id)}>Delete</button>
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// };

// export default SampleCrudComponent;
